// 定义全局api接口地址，用于接收根据当前环境判读后使用的api-url地址
let apiUrl

// 判断环境变量
if (process.env.NODE_ENV === 'development') { // 开发环境
  apiUrl = {
    bdcUrl: 'https://gateway.yingxiong.com/bdc4-server',
    gateUrl: 'https://test-gateway.yingxiong.com/bdc4-gateway',
    gameUrl: 'https://test-gateway.yingxiong.com/console-game'
  }
} else if (process.env.VUE_APP_TITLE === 'stage') { // 预上线（测试环境）
  apiUrl = {
    bdcUrl: 'https://gateway.yingxiong.com/bdc4-server',
    gateUrl: 'https://test-gateway.yingxiong.com/bdc4-gateway',
    gameUrl: 'https://test-gateway.yingxiong.com/console-game'
  }
} else if (process.env.VUE_APP_TITLE === 'production') { // 正式环境
  apiUrl = {
    bdcUrl: 'https://gateway.yingxiong.com/bdc4-server',
    gateUrl: 'https://gateway.yingxiong.com/bdc4-gateway',
    gameUrl: 'https://gateway.yingxiong.com/console-game'
  }
} else if (process.env.VUE_APP_TITLE === 'k8s3') { // 正式环境
  apiUrl = {
    bdcUrl: 'https://gateway.yingxiong.com/bdc4-server',
    gateUrl: 'https://gateway.yingxiong.com/bdc4-gateway',
    gameUrl: 'https://gateway.yingxiong.com/console-game'
  }
}

export {
  apiUrl
}
